/**
 * 热点聚焦路由
 * 2017-11-19
 * Bai.Zhiming
 */
"use strict";
angular.module("hotFocusRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.
    state("front.plan.hotfocus.regionalhotspots", {
        url: "/regionalhotspots",
        views: {
            "main@front.plan.hotfocus": {
                template: "<div ui-view='main'></div>",
                controller: "regionalHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.fieldhotspots", {
        url: "/fieldhotspots",
        views: {
            "main@front.plan.hotfocus": {
                templateUrl: "./planningCenter/hotFocus/fieldHotSpots/fieldHotSpots_tpl.html",
                controller: "fieldHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.timehotspots", {
        url: "/timehotspots",
        views: {
            "main@front.plan.hotfocus": {
                templateUrl: "./planningCenter/hotFocus/timeHotSpots/timeHotSpots_tpl.html",
                controller: "timeHotSpotsCtrl"
            }
        }
    }).
    state("front.plan.hotfocus.classifyhotspots", {
        url: "/classifyhotspots",
        views: {
            "main@front.plan.hotfocus": {
                template: "<div ui-view='main'></div>"
            }
        }
    }).
    state("front.plan.hotfocus.channelHotSpots", {
        url: "/channelHotSpots",
        views: {
            "main@front.plan.hotfocus": {
                template: "<div class='channelHotSpotsMain' ui-view='main'></div>"
            }
        }
    })
}]);